import React from 'react';
import NavigationBody from 'components/navigation/Navigation';

const Navigation = props => <NavigationBody {...props} />;

export default Navigation;
